<form #costDescriptionForm="ngForm" role="form" class="cost-description-container">
  @if (commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.PC_TO_CONTRACT) {
    <app-dropdown
      name="cost_description_{{ costIndex }}"
      optionLabel="name"
      optionValue="sov_id"
      [required]="true"
      placeholder="Description {{ costIndex + 1 }}"
      label="Description {{ costIndex + 1 }}"
      [(ngModel)]="model.sov_id"
      (ngModelChange)="updateModel()"
      [options]="primeContractSOVs()"
      [disabledOptionIds]="disabledOptionIds()"
      class="w-full"
    >
    </app-dropdown>
  } @else if (!model.is_dropdown) {
    <app-floating-input
      [required]="true"
      name="cost_description_{{ costIndex }}"
      [(ngModel)]="model.name"
      (ngModelChange)="updateModel()"
      placeholder="Description {{ costIndex + 1 }}"
      label="Description {{ costIndex + 1 }}"
    ></app-floating-input>
  } @else {
    <app-floating-input
      #costViewTrigger="cdkOverlayOrigin"
      [disabled]="model?.has_commitments"
      (click)="!model?.has_commitments && (isDropdownShown.name[costIndex] = true)"
      required
      cdkOverlayOrigin
      readonly
      type="text"
      name="dropdownInput_{{ costIndex }}"
      [ngModel]="model.name"
      placeholder="Description {{ costIndex + 1 }}"
      label="Description {{ costIndex + 1 }}"
      class="w-full cursor-pointer"
      inputClass="cursor-pointer"
      [iconClass]="isDropdownShown.name[costIndex] ? 'dropdown-icon opened' : 'dropdown-icon closed'"
    ></app-floating-input>

    <app-overlay-general
      [(show)]="isDropdownShown.name[costIndex]"
      [trigger]="costViewTrigger"
      [overlayPositions]="dropdownAlignRight"
      [ngClass]="{ 'p-disabled': model?.has_commitments }"
    >
      <app-cost-view-table-dropdown
        [costIndex]="costIndex"
        [spendEntryIndex]="spendEntryIndex"
        [commitmentType]="commitmentType"
        (closeMe)="isDropdownShown.name[costIndex] = false"
        [disableAdd]="model?.is_disabled && commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER"
        [disableDelete]="model.is_disabled && commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.CHANGE_ORDER"
      >
      </app-cost-view-table-dropdown>
    </app-overlay-general>
  }

  <app-floating-input
    [required]="true"
    [disabled]="commitmentType === COMMITMENTS_INTERACTION_BAR_TYPE.PC_TO_CONTRACT"
    name="value_{{ costIndex }}"
    [(ngModel)]="model.value"
    (change)="updateModel()"
    [autoComplete]="false"
    placeholder="Value ($)"
    label="Value ($)"
    type="money"
  >
  </app-floating-input>

  <app-add-remove-buttons
    class="mt-3.5"
    [disabledRemove]="model?.has_commitments || model?.is_disabled || totalCostCount === 1"
    [disableAddTooltip]="disabledAddDescriptionTooltip()"
    [disabledAdd]="disableAddDescription() || model?.is_disabled"
    (removeItem)="askRemoveSubItem()"
    (addItem)="addCost()"
  >
  </app-add-remove-buttons>
</form>
